module.exports = __webpack_public_path__ + "static/media/font.183eb94e.png";